// extracted by mini-css-extract-plugin
export var accordionBody = "component-module--accordionBody--85454";
export var hidden = "component-module--hidden--403fc";